import {FreeToPlayAnimatedIconDefaultBox} from "./free-to-play-animated-icon.default.box";

export const FreeToPlayAnimatedIconBox = FreeToPlayAnimatedIconDefaultBox;